import React, { useEffect, useState } from 'react';
import { Modal, ModalOverlay, ModalContent } from '@hover/blueprint/chakra';
import { AspectRatio } from '@chakra-ui/react';
import styled from '@emotion/styled';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  isVertical?: boolean;
}

const VideoModal: React.FC<Props> = ({ isOpen, onClose, isVertical }) => {
  const [videoHTML, setVideoHTML] = useState<string>('');

  useEffect(() => {
    const htmlText = `<div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative; width: 100%"><div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;"><div class="wistia_embed wistia_async_ox4ggikir1 muted=false playbar=true playerColor=000000 autoPlay=true end" style="height:100%;position:relative;width:100%"><div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"><img src="https://fast.wistia.com/embed/medias/ox4ggikir1/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" aria-hidden="true" onload="this.parentNode.style.opacity=1;" /></div></div></div></div>`;
    setVideoHTML(htmlText);
  }, []);

  const VideoWrapper = styled.div`
    width: 100%;
    max-width: 100%;
    display: block;
  `;
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        padding="0px !important"
        margin="0px"
        background="transparent"
        boxShadow="none"
        borderRadius="8px"
        overflow="hidden"
        width={
          isVertical
            ? {
                base: '330px',
                desktop: '394px;',
              }
            : {
                base: '90vw',
                tablet: '680px',
                desktop: '960px',
                xl: '80vw',
              }
        }
      >
        <AspectRatio
          w="100%"
          height={
            isVertical
              ? { base: '586px', desktop: '683px' }
              : { base: 'calc(90vw - 40vw)', tablet: '383px', desktop: '540px' }
          }
        >
          <VideoWrapper dangerouslySetInnerHTML={{ __html: videoHTML }} />
        </AspectRatio>
      </ModalContent>
    </Modal>
  );
};

export default VideoModal;
